import { render, staticRenderFns } from "./Dancers.vue?vue&type=template&id=2c058367&scoped=true&"
import script from "./Dancers.vue?vue&type=script&lang=js&"
export * from "./Dancers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c058367",
  null
  
)

export default component.exports